/**
 * LicenseNotFoundCard — shared "no active license" card, rendered both by
 * the standalone /license-error route (LicenseError.tsx) and by LicenseGate
 * when it blocks access inline. Keeping one copy avoids the two drifting.
 */

import type { ReactNode } from 'react';
import StatusScreen, { StatusInfoBox } from '../layout/StatusScreen';
import { CopyTenantId } from './CopyTenantId';

const WarningIcon = (
  <svg
    width='32'
    height='32'
    fill='none'
    stroke='currentColor'
    viewBox='0 0 24 24'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={2}
      d='M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z'
    />
  </svg>
);

interface LicenseNotFoundCardProps {
  tenantId: string;
  subtitle?: ReactNode;
  actions: ReactNode;
}

export function LicenseNotFoundCard({
  tenantId,
  subtitle,
  actions,
}: LicenseNotFoundCardProps) {
  return (
    <StatusScreen
      iconBg='#fef2f2'
      iconColor='#ef4444'
      icon={WarningIcon}
      title='License Not Found'
      subtitle={
        subtitle ??
        'Your organisation does not have an active Content Trust Dashboard license.'
      }
      actions={actions}
    >
      {tenantId && <CopyTenantId tenantId={tenantId} />}

      <StatusInfoBox title='To get started:'>
        <ol
          style={{
            margin: 0,
            paddingLeft: 18,
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}
        >
          <li>Copy your Tenant ID above</li>
          <li>
            Send it to your IT admin or{' '}
            <a
              href='mailto:support@injio.com.au'
              style={{
                color: '#0284c7',
                fontWeight: 600,
                textDecoration: 'none',
              }}
            >
              Injio support
            </a>
          </li>
          <li>Once the license is activated, refresh this page</li>
        </ol>
      </StatusInfoBox>
    </StatusScreen>
  );
}
